export const bySort = (a: { sort: number }, b: { sort: number }) => {
  if (a.sort === null) return 1
  if (b.sort === null) return -1
  return a.sort - b.sort
}
